'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('TrackerIntroCtrl', TrackerIntroCtrl);

  TrackerIntroCtrl.$inject = ['$log', '$state', 'NotifyingSvc', 'moodTrackerSvc', 'userSvc', '$timeout'];

  /* @ngInject */
  function TrackerIntroCtrl($log, $state, NotifyingSvc, moodTrackerSvc, userSvc, $timeout) {
    var vm = this;
    vm.title = 'TrackerIntroCtrl';

    activate();

    vm.openRecordMultipleTrackerValuesModal = function (trackersArray, messageId, defaultMessage) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'tracker/templates/record-multiple-tracker-values-modal.html',
        controller: 'RecordMultipleTrackerValuesModalCtrl',
        controllerAs: 'vm',
        inputs: {
          trackers: trackersArray,
          messageId: messageId,
          defaultMessage: defaultMessage
        },
        closeCallback: recordNewTrackerEntryCallback
      });
    };

    vm.openEditTrackerListModal = function (trackedMoods) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'tracker/templates/edit-tracker-list-modal.html',
        controller: 'EditTrackerListModalCtrl',
        inputs: {
          trackers: trackedMoods,
          allMoods: vm.allMoods
        },
        closeCallback: editTrackerListCallback
      });
    };

    function _navigateToChart() {
      $timeout(function () {
        $state.go('vnext.content.tracker.main.chart');
      }, 320);
    }
    ////////////////

    function recordNewTrackerEntryCallback() {
      userSvc.savePreferences({
        seenTrackerIntro: true
      }, _navigateToChart, _navigateToChart);
    }

    function editTrackerListCallback(chosenTrackers) {
      // Give the modal time to close, wait 300ms + 20ms just to be safe.
      $timeout(function () {
        $state.go('vnext.content.tracker.intro.entry');
      }, 320);
      vm.trackedMoods = chosenTrackers;
    }

    function activate() {
      $log.debug('Tracker intro control activate');
      // initiate default queries
      moodTrackerSvc.getTrackedMoods().then(function (data) {
        vm.trackedMoods = data;
      });
      moodTrackerSvc.getAllMoods().then(function (data) {
        vm.allMoods = data;
      });
    }
  }
})();